export var PadType = /*#__PURE__*/function (PadType) {
  PadType["Doc"] = "doc";
  PadType["Sheet"] = "sheet";
  PadType["Form"] = "form";
  PadType["Folder"] = "folder";
  PadType["Slide"] = "slide";
  PadType["Note"] = "note";
  PadType["Pdf"] = "pdf";
  PadType["MiniProgram"] = "aio";
  PadType["Aio"] = "aio";
  PadType["Unknown"] = "unknown";
  PadType["Resume"] = "resume";
  PadType["Ofd"] = "ofd";
  PadType["RelationGraph"] = "relationGraph";
  PadType["Mind"] = "mind";
  PadType["FlowChart"] = "flowchart";
  PadType["Board"] = "board";
  PadType["Markdown"] = "markdown";
  PadType["File"] = "file";
  PadType["Drive"] = "drive";
  PadType["SogouSpeech"] = "rec";
  PadType["Addon"] = "addon";
  PadType["SmartCanvas"] = "smartcanvas";
  PadType["SmartSheet"] = "smartsheet";
  PadType["LocalFile"] = "local_file";
  return PadType;
}({});
//# sourceMappingURL=pad-type.js.map